import { Trigger } from "@dxos/async";
import { log } from "@dxos/log";
//#region src/packlets/diagnostics/browser-diagnostics-broadcast.ts
var __dxlog_file = "/__w/dxos/dxos/packages/sdk/client-services/src/packlets/diagnostics/browser-diagnostics-broadcast.ts";
var CHANNEL_NAME = "dxos.diagnostics.broadcast";
var createCollectDiagnosticsBroadcastSender = () => {
	return { broadcastDiagnosticsRequest: async () => {
		let expectedResponse = "probe-ack";
		let channel;
		try {
			const trigger = new Trigger();
			channel = new BroadcastChannel(CHANNEL_NAME);
			channel.onmessage = (msg) => {
				if (expectedResponse === msg.data.type) trigger.wake(msg.data);
			};
			channel.postMessage({ type: "probe" });
			await trigger.wait({ timeout: 200 });
			expectedResponse = "receive-diagnostics";
			trigger.reset();
			channel.postMessage({ type: "request-diagnostics" });
			return (await trigger.wait({ timeout: 5e3 })).payload;
		} catch (e) {
			const errorDescription = e instanceof Error ? e.message : JSON.stringify(e);
			return {
				expectedResponse,
				errorDescription
			};
		} finally {
			safeClose(channel);
		}
	} };
};
var createCollectDiagnosticsBroadcastHandler = (systemService) => {
	let channel;
	return {
		start: () => {
			channel = new BroadcastChannel(CHANNEL_NAME);
			channel.onmessage = async (message) => {
				try {
					if (message.data.type === "probe") channel?.postMessage({ type: "probe-ack" });
					else if (message.data.type === "request-diagnostics") {
						const diagnostics = await systemService.getDiagnostics({});
						channel?.postMessage({
							type: "receive-diagnostics",
							payload: diagnostics
						});
					}
				} catch (error) {
					log.catch(error, void 0, {
						"~LogMeta": "~LogMeta",
						F: __dxlog_file,
						L: 77,
						S: void 0
					});
				}
			};
		},
		stop: () => {
			safeClose(channel);
			channel = void 0;
		}
	};
};
var safeClose = (channel) => {
	try {
		channel?.close();
	} catch (e) {}
};
//#endregion
export { createCollectDiagnosticsBroadcastHandler, createCollectDiagnosticsBroadcastSender };

//# sourceMappingURL=browser-diagnostics-broadcast.mjs.map